import env from '@polleverywhere/core/lib/env'
import { inIframe } from '../util/in_iframe'
import { slice as appSlice } from '../slices/app'
import store from '@polleverywhere/redux'
import { slice as profileSlice } from '@polleverywhere/redux/slices/profile'
import listenToSelector from '../util/listen_to_selector'

/* global Rollbar */

function rollbarEnvironment () {
  const { role, mode } = store.getState()[appSlice.name]

  const environmentParts = [role]

  // We are slowly phasing out 'integration' mode in favor 'slideware'.
  // TODO: remove this when we remove integration mode
  if (role !== 'slideware' && mode === 'integration') {
    environmentParts.push('integration')
  }

  environmentParts.push(env.get('rollbar_environment'))

  return environmentParts.join('-')
}

// Configure Rollbar depending on app state
export default (app) => {
  typeof Rollbar !== 'undefined' && Rollbar !== null && Rollbar.configure({
    transform: (payload) => {
      payload.state = app.state.inspect()

      // delete PII
      delete payload.state.user?.email
      delete payload.state.user?.first_name
      delete payload.state.user?.last_name
    },
    payload: {
      environment: rollbarEnvironment(),
      iframed: inIframe()
    },
    hostSafeList: [window.location.hostname, env.get('cdn_url')?.hostname()],
    reportLevel: 'error'
  })

  listenToSelector((state) => state[appSlice.name].role, () => {
    typeof Rollbar !== 'undefined' && Rollbar !== null && Rollbar.configure({
      payload: {
        environment: rollbarEnvironment()
      }
    })
  })

  listenToSelector((state) => appSlice.selectIsSessionStarted(state), () => {
    const { user, participant } = store.getState()[profileSlice.name]

    typeof Rollbar !== 'undefined' && Rollbar !== null && Rollbar.configure({
      payload: {
        person: {
          // undefined does not overwrite existing value
          id: participant.id || null,
          username: user.login || null
        }
      }
    })
  })
}
